import React from "react";
import Booking from "../components/Booking";
import Review from "../components/Review";
import { useSelector } from "react-redux";

export default function Home() {
  const activeStep = useSelector((state) => state.registration.activeStep);

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return <Booking />;
      case 1:
        return <Review />;
      default:
        throw new Error("unknown step");
    }
  };

  return <>{getStepContent(activeStep)}</>;
}
